var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-url"},[_c('v-text-field',{staticClass:"copy-url__input",attrs:{"id":_vm.inputId,"outlined":"","dense":"","hide-details":"","readonly":"","prepend-inner-icon":"mdi-link-variant"},on:{"click:prepend-inner":_vm.copyUrl},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }